import memoize from 'lru-memoize';
import { createValidator, required, email } from 'utils/validation';

const forgotValidation = createValidator({
  username: [email, required],
});

export default memoize(10)(forgotValidation);
